module.exports = __webpack_public_path__ + "img/daan.8f49999d.jpg";